// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"be069a99ac3264f7","818":"cb785deb7d81d0be","955":"519b4372d6531526"}[chunkId] + ".js";
};